module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thematic-news"
  }, [_c('img', {
    staticStyle: {
      "z-index": "-10",
      "position": "absolute"
    },
    attrs: {
      "src": "https://img.qiluyidian.net/shareimg20191216.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    ref: "tips",
    staticClass: "tips clearfix"
  }, [_c('span', {
    staticClass: "homeIcon",
    style: ({
      backgroundImage: _vm.home_url,
      backgroundSize: '100%'
    }),
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "rightLine"
  }), _vm._v(" "), _c('span', {
    staticClass: "slogon"
  }, [_vm._v("齐鲁晚报官方APP")]), _vm._v(" "), _c('span', {
    staticClass: "openApp",
    on: {
      "click": _vm.down
    }
  }, [_vm._v("打开")])]), _vm._v(" "), (_vm.loading == 0) ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: _vm.loading_url,
      backgroundSize: '20%'
    })
  }) : (_vm.loading == 1) ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: _vm.error1_url,
      backgroundSize: '50%'
    })
  }) : (_vm.loading == 2) ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: _vm.deleted_url,
      backgroundSize: '50%'
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "thematicInfo clearfix"
  }, [(_vm.thematicInfo.headimg) ? _c('img', {
    staticClass: "themePic",
    attrs: {
      "src": _vm.thematicInfo.headimg,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "themePic",
    attrs: {
      "src": require("../../common/img/defaultPicture.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "thematicIntro"
  }, [_c('div', {
    staticClass: "intro clearfix"
  }, [_c('span', {
    staticClass: "stratIntro"
  }, [_c('i', {
    staticClass: "icon",
    style: ({
      backgroundImage: _vm.thematic_url,
      backgroundSize: 'contain'
    })
  }), _vm._v(" "), _c('i', {
    staticClass: "line"
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.thematicInfo.content))])]), _vm._v(" "), (_vm.thematicInfo.view_count) ? _c('div', {
    staticClass: "themViewCount"
  }, [_vm._v("专题阅读量" + _vm._s(_vm.thematicInfo.view_count))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tags clearfix"
  }, _vm._l((_vm.thematicInfo.labelList), function(item, index) {
    return _c('span', {
      staticClass: "tagBorder"
    }, [_c('span', {
      staticClass: "tagBg",
      on: {
        "click": function($event) {
          return _vm.tagJump(index)
        }
      }
    }, [_vm._v(_vm._s(item))])])
  }), 0)])]), _vm._v(" "), _vm._l((_vm.thematicInfo.subjectItemNewsList), function(lists) {
    return _c('div', {
      staticClass: "list"
    }, [_c('div', {
      staticClass: "listWrapper"
    }, [(lists.label) ? _c('p', {
      staticClass: "listName"
    }, [_c('span', [_vm._v(_vm._s(lists.label))])]) : _vm._e(), _vm._v(" "), _vm._l((lists.subjectNewsList), function(item, index) {
      return _c('div', {
        staticClass: "newType"
      }, [(item.isAd == '1') ? _c('div', {
        staticClass: "newListAdv",
        on: {
          "click": function($event) {
            return _vm.goMost(item.type, item.sourceId, item.detailurl, item.status)
          }
        }
      }, [_c('p', {
        staticClass: "advTitle"
      }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), (item.conentimg1) ? _c('img', {
        staticClass: "advImg",
        attrs: {
          "src": item.conentimg1 + _vm.param,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "advImg",
        attrs: {
          "src": require("../../common/img/defaultPicture.png"),
          "alt": ""
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "advText adColor1 clearfix"
      }, [_vm._v("广告")])]) : (item.conenttype == '1' || item.conenttype == '20') ? _c('div', {
        staticClass: "newList clearfix",
        on: {
          "click": function($event) {
            return _vm.goGeneral(item.conentid)
          }
        }
      }, [(item.conentimg1) ? _c('img', {
        staticClass: "newImg",
        attrs: {
          "src": item.conentimg1 + _vm.param,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "newImg",
        attrs: {
          "src": require("../../common/img/defaultPicture.png"),
          "alt": ""
        }
      }), _vm._v(" "), (item.conenttype == '20') ? _c('img', {
        staticClass: "ypTips",
        attrs: {
          "src": require("../../common/img/ypTips.png"),
          "alt": ""
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "newsRight"
      }, [_c('p', {
        staticClass: "newsTitle"
      }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), _c('p', {
        staticClass: "timeView"
      }, [_c('span', {
        staticClass: "source"
      }, [_vm._v(_vm._s(item.timestr))]), _vm._v(" "), (item.viewcount != 0 && item.viewcount != '' && item.viewcount >= 1000 || item.viewcount.indexOf('万') != '-1') ? _c('span', {
        staticClass: "yue"
      }, [_vm._v(_vm._s(item.viewcount) + "阅")]) : _vm._e(), _vm._v(" "), (item.commentcount != 0 && item.commentcount != '' && item.viewcount < 1000 && item.viewcount.indexOf('万') == '-1') ? _c('span', {
        staticClass: "ping"
      }, [_vm._v(_vm._s(item.commentcount) + "评")]) : _vm._e()])])]) : (item.conenttype == '10') ? _c('div', {
        staticClass: "newListAdv",
        on: {
          "click": function($event) {
            return _vm.goLive(item.conentid)
          }
        }
      }, [_c('p', {
        staticClass: "advTitle"
      }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), (item.conentimg1) ? _c('img', {
        staticClass: "advImg",
        attrs: {
          "src": item.conentimg1 + _vm.param,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "advImg",
        attrs: {
          "src": require("../../common/img/defaultPicture.png"),
          "alt": ""
        }
      }), _vm._v(" "), (item.conenttype == '6') ? _c('p', {
        staticClass: "advText adColor1"
      }, [_vm._v("活动")]) : (item.conenttype == '5') ? _c('p', {
        staticClass: "advText adColor1"
      }, [_vm._v("商品")]) : (item.conenttype == '8') ? _c('p', {
        staticClass: "advText adColor1"
      }, [_vm._v("图文直播")]) : (item.conenttype == '10' && item.status == '2') ? _c('p', {
        staticClass: "advText adColor1"
      }, [_vm._v("预告")]) : (item.conenttype == '10' && item.status == '1') ? _c('p', {
        staticClass: "advText adColor2"
      }, [_vm._v("直播")]) : _c('p', {
        staticClass: "advText adColor0"
      }, [_vm._v("回顾")])]) : (item.conenttype == '6' || item.conenttype == '5' || item.conenttype == '8') ? _c('div', {
        staticClass: "newListAdv",
        on: {
          "click": function($event) {
            return _vm.goMost(item.type, item.sourceId, item.detailurl, item.status)
          }
        }
      }, [_c('p', {
        staticClass: "advTitle"
      }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), (item.conentimg1) ? _c('img', {
        staticClass: "advImg",
        attrs: {
          "src": item.conentimg1 + _vm.param,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "advImg",
        attrs: {
          "src": require("../../common/img/defaultPicture.png"),
          "alt": ""
        }
      }), _vm._v(" "), (item.conenttype == '6') ? _c('p', {
        staticClass: "advText adColor1"
      }, [_vm._v("活动")]) : (item.conenttype == '5') ? _c('p', {
        staticClass: "advText adColor1"
      }, [_vm._v("商品")]) : (item.conenttype == '8') ? _c('p', {
        staticClass: "advText adColor1"
      }, [_vm._v("图文直播")]) : (item.conenttype == '10' && item.status == '2') ? _c('p', {
        staticClass: "advText adColor1"
      }, [_vm._v("预告")]) : (item.conenttype == '10' && item.status == '1') ? _c('p', {
        staticClass: "advText adColor2"
      }, [_vm._v("直播")]) : _c('p', {
        staticClass: "advText adColor0"
      }, [_vm._v("回顾")])]) : (item.conenttype == '3') ? _c('div', {
        staticClass: "newListVideo",
        on: {
          "click": function($event) {
            return _vm.goVideo(item.conentid)
          }
        }
      }, [_c('p', {
        staticClass: "videoTitle"
      }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), _c('div', {
        staticClass: "videoWraper"
      }, [(item.conentimg1) ? _c('img', {
        staticClass: "videoImg",
        attrs: {
          "src": item.conentimg1 + _vm.param,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "videoImg",
        attrs: {
          "src": require("../../common/img/defaultPicture.png"),
          "alt": ""
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "stop",
        style: ({
          backgroundImage: _vm.stop_url,
          backgroundSize: '13%'
        })
      })]), _vm._v(" "), _c('p', {
        staticClass: "videoDetail"
      }, [(item.columnName) ? _c('span', {
        staticClass: "videoText"
      }, [_vm._v(_vm._s(item.columnName))]) : (item.ownername) ? _c('span', {
        staticClass: "videoText"
      }, [_vm._v(_vm._s(item.ownername))]) : _c('span', {
        staticClass: "videoText"
      }, [_vm._v(_vm._s(item.source))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.timestr))])])]) : (item.conenttype == '2') ? _c('div', {
        staticClass: "newListPic",
        on: {
          "click": function($event) {
            return _vm.goAtlas(item.conentid)
          }
        }
      }, [_c('p', {
        staticClass: "picTitle"
      }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), _c('div', {
        staticClass: "picWraper"
      }, [(item.conentimg1) ? _c('img', {
        staticClass: "picImg",
        attrs: {
          "src": item.conentimg1 + _vm.param,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "picImg",
        attrs: {
          "src": require("../../common/img/defaultPicture.png"),
          "alt": ""
        }
      }), _vm._v(" "), (item.conentimg2) ? _c('img', {
        staticClass: "picImg",
        attrs: {
          "src": item.conentimg2 + _vm.param,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "picImg",
        attrs: {
          "src": require("../../common/img/defaultPicture.png"),
          "alt": ""
        }
      }), _vm._v(" "), (item.conentimg3) ? _c('img', {
        staticClass: "picImg",
        attrs: {
          "src": item.conentimg3 + _vm.param,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "picImg",
        attrs: {
          "src": require("../../common/img/defaultPicture.png"),
          "alt": ""
        }
      })])]) : (item.conenttype == '4') ? _c('div', {
        ref: "thematicPic",
        refInFor: true,
        staticClass: "thematicPic",
        on: {
          "click": function($event) {
            return _vm.goThematic(item.conentid)
          }
        }
      }, [_c('p', {
        staticClass: "picTitle"
      }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), _c('div', {
        staticClass: "picWraper0"
      }, [_c('div', {
        staticClass: "picWraper"
      }, _vm._l((item.subjectNewsList), function(itm) {
        return (itm.conentimg1) ? _c('img', {
          staticClass: "picImg",
          attrs: {
            "src": itm.conentimg1 + _vm.param,
            "alt": ""
          }
        }) : _c('img', {
          staticClass: "picImg",
          attrs: {
            "src": require("../../common/img/defaultPicture.png"),
            "alt": ""
          }
        })
      }), 0)])]) : _vm._e(), _vm._v(" "), (index < lists.subjectNewsList.length - 1) ? _c('i', {
        staticClass: "line"
      }) : _vm._e()])
    })], 2)])
  }), _vm._v(" "), (_vm.topShow) ? _c('div', {
    staticClass: "toTop"
  }, [_c('span', {
    staticClass: "index",
    style: ({
      backgroundImage: _vm.index_url,
      backgroundSize: 'contain'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goHome.apply(null, arguments)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blockWhite"
  }, [_vm._v("加载完毕")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53ff9f66!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/thematic/App.vue
// module id = 412
// module chunks = 13